import React from 'react';
import PageBanner from 'components/banners/PageBanner';
import Features from 'components/Features';
import { Col, Container, Row, Image } from 'react-bootstrap';
import styles from './addons.module.scss';
import computer from 'assets/images/Tools-signature-cap60.jpeg';
import { Helmet } from 'react-helmet';
import RequestDemoButton from 'components/RequestDemoButton';
const FEATURE_DATA = [
  {
    id: '01',
    title: 'Lower Supply Costs.',
  },
  {
    id: '02',
    title: 'Unique Document Upload.',
  },
  {
    id: '03',
    title: 'Document Retrieval.',
  },
  {
    id: '03',
    title: 'Off Sight Signature Capture.',
  },
];
function ElectronicSignature() {
  return (
    <div>
      <Helmet>
        <title>Electronic Signature - CAP60</title>
        <meta
          name="description"
          content="With CAP60’s Electronic Signature Capture you can attach a signature to any form in the CAP60 database and retrieve those signed documents from any location."
        />
        <meta
          name="keyword"
          content="electronic signature, cap60 electronic signature"
        />
      </Helmet>
      <PageBanner
        title="Attach signatures to any document"
        subtitle="Great for Off-site signature collection."
      />
      <ClienDesk />
      <div className="floralbg-blue">
        <Container className="overflow-auto">
          <Features
            data={FEATURE_DATA}
            variant="secondary"
            title="Features"
            itemsPerRow={4}
            subtitle="Dig in to know what make CAP60 Solutions unique and useful."
            itemClass={styles.featureItem}
          />
        </Container>
      </div>
    </div>
  );
}

function ClienDesk() {
  return (
    <div className={styles.clientDeskWrapper}>
      <Container>
        <Row>
          <Col md="7">
            <div className="heading">
              <h2>Great for Off-site signature collection</h2>
            </div>
            <p>
              With CAP60’s Electronic Signature Capture you can attach a
              signature to any form in the CAP60 database and retrieve those
              signed documents from any location.
            </p>
            <p>
              With the electronic signature feature, you can sign and submit
              important agency and program documents from both on site and off.
              The Electronic Signature Capture makes document signing, storing
              and retrieval fast and organized while reducing company waste and
              lowering supply costs.
            </p>

            <RequestDemoButton />
          </Col>
          <Col md="5">
            <div className={styles.rightDark}>
              <Image src={computer} />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default ElectronicSignature;
